import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/authenticate.service';
import { NotificationService } from '../services/notification.service';
import { LoaderService } from '../shared/loader/loader.service';
import * as constants from '../config/app.constants';

@Component({
    selector: 'app-activate_user',
    templateUrl: 'activate_user.component.html',
    styleUrls: ['activate_user.component.css'],
    standalone: false
})
export class Activate_userComponent {
  form: FormGroup = new FormGroup({});
  showForgotPassword: boolean = false;
  requested: Boolean = false;
  constructor(private authService: AuthService,
    private router: Router
    , private toast: NotificationService
    , private loader: LoaderService) {
    this.initiateFormGroup();
  }

  initiateFormGroup() {
    this.form = new FormGroup({
      'userName': new FormControl("", [Validators.required]),
      'email': new FormControl("", [Validators.pattern(constants.VALIDATE_EMAIL_ADDRESS)])
    })
  }

  submitPage() {
    if (this.validatePage()) {
      this.loader.start();
      this.authService.activateUse(this.form.value).subscribe(res => {
        this.loader.stop();
        this.toast.showSuccess("User activated successfully. Please login to the system");
        this.router.navigate(['/login']);
      }
        ,
        error => {
          this.loader.stop();
          if (error) {
            if (error.status == 200) {
            } else {
              this.toast.showError(error.error.apierror.message);
            }
          } else {
            this.toast.showError("Error occured while saving");
          }
        }
      )
    }
  }

  reset() {
    this.router.navigate(['/login']);
  }

  validatePage(): boolean {
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.markAsDirty();
        this.form.get(key)?.markAsTouched();
      }
    })
    return this.form.valid;
  }
}
